import React from 'react';

import styled, { keyframes, css } from 'styled-components';

import { assistantMessageBubbleStyles } from './message_styles';

type Props = {
  children: React.ReactNode;
};

export function Shimmer({ children }: Props) {
  return (
    <div>
      <Effect>{children}</Effect>
    </div>
  );
}

const shimmerAnimation = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const shimmerEffect = css`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: ${shimmerAnimation} 1.5s infinite;
  }
`;

const Effect = styled.span`
  ${assistantMessageBubbleStyles}
  display: inline-block;
  position: relative;
  overflow: hidden;
  ${shimmerEffect}
`;
